
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/dodaj-karte-sim",
      function () {
        return require("private-next-pages/moje-konto/dodaj-karte-sim.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/dodaj-karte-sim"])
      });
    }
  